import { useTranslate } from '@/hooks/useTranslate';
import { Button } from '@/components/Common/Button';
import { ButtonType } from '@/types/components';
import visaLogo from '@/assets/icons/payments/visa.svg';
import mastercardLogo from '@/assets/icons/payments/mastercard.svg';
import amexLogo from '@/assets/icons/payments/amex.svg';

interface UseOtherPaymentMethodLinkProps {
  onClick: () => void;
  showIcons: boolean;
}

/**
 * Escape hatch rendered below the primary CTA. Shared by the preferred-payment
 * views so the link stays visually identical — only the wrapping column differs.
 */
export const UseOtherPaymentMethodLink = ({ onClick, showIcons }: UseOtherPaymentMethodLinkProps) => {
  const { t } = useTranslate();
  return (
    <div className="flex flex-col">
      <div className="flex justify-center">
        <Button type={ButtonType.LINK} className="text-center w-auto h-7 cursor-pointer" onClick={onClick}>
          {t('useOtherPaymentMethod')}
        </Button>
      </div>
      {showIcons && <OtherPaymentMethodIcons />}
    </div>
  );
};

const OtherPaymentMethodIcons = () => {
  return (
    <div className="flex items-center justify-center gap-1">
      <img src={visaLogo} alt="visa" className="h-4" />
      <img src={mastercardLogo} alt="mastercard" className="h-4" />
      <img src={amexLogo} alt="amex" className="h-4" />
    </div>
  );
};
